(function () {
  'use strict';
  if (customElements.get('upk-band-charm')) return;

  // Real cart total (paise) required before checkout is allowed, kept in
  // sync with the same threshold used in snippets/cart-drawer.liquid,
  // sections/main-cart-footer.liquid and assets/upk-pdp.js. Reads the
  // single shared value set in layout/theme.liquid, falling back to the
  // same literal if that global isn't present for any reason.
  var UPK_MIN_ORDER_PAISE = (typeof window.UPK_MIN_ORDER_PAISE === 'number') ? window.UPK_MIN_ORDER_PAISE : 15000; /* OPEN-ITEMS 128 (D37): ₹150 after discounts; below it, Buy it now lands on the cart page with the gate */
  function upkRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function escAttr(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function fmtINR(cents) {
    var rupees = Math.round(cents / 100);
    return '₹\u00a0' + rupees.toLocaleString('en-IN');
  }

  function keyOutWhite(img) {
    var w = img.naturalWidth, h = img.naturalHeight;
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0);
    var d = ctx.getImageData(0, 0, w, h);
    var p = d.data;
    var minX = w, minY = h, maxX = -1, maxY = -1;
    var kept = 0;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i4 = (y * w + x) * 4;
        var r = p[i4], g = p[i4 + 1], b = p[i4 + 2];
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
        var sat = mx - mn;
        if (mn > 222 && sat < 30) {
          p[i4 + 3] = 0;
        } else if (mn > 195 && sat < 38) {
          p[i4 + 3] = Math.round(p[i4 + 3] * (222 - mn) / 27);
        }
        if (p[i4 + 3] > 24) {
          kept++;
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    var total = w * h;
    if (maxX < 0 || kept < total * 0.02 || kept > total * 0.97) return null;
    ctx.putImageData(d, 0, 0);
    var pad = Math.max(1, Math.round(Math.max(w, h) * 0.005));
    minX = Math.max(0, minX - pad); minY = Math.max(0, minY - pad);
    maxX = Math.min(w - 1, maxX + pad); maxY = Math.min(h - 1, maxY + pad);
    var cw = maxX - minX + 1, ch = maxY - minY + 1;
    var c2 = document.createElement('canvas');
    c2.width = cw; c2.height = ch;
    c2.getContext('2d').drawImage(c, minX, minY, cw, ch, 0, 0, cw, ch);
    return c2.toDataURL('image/png');
  }

  /* 21 Oct (from Dawn (Zainab)): the catalog grid also takes the extras listed in charm_variants / _2 / _3 that the
     catalog JSON misses (data-bc-catalog-extra), and a GID id (gid://shopify/ProductVariant/123) is cut to the plain
     number the cart needs. */
  function plainId(id) { return String(id == null ? '' : id).split('/').pop(); }
  function buildCharmGrid(grid) {
    var host = grid.closest('upk-band-charm') || document;
    var dataEl = host.querySelector('[data-bc-catalog]');
    if (!dataEl) return;
    var catalog = [];
    try { catalog = JSON.parse(dataEl.textContent) || []; } catch (e) { catalog = []; }
    var extraEl = host.querySelector('[data-bc-catalog-extra]');
    if (extraEl) {
      try {
        var extra = JSON.parse(extraEl.textContent) || [];
        var seen = {};
        catalog.forEach(function (c) { seen[plainId(c.id)] = true; });
        extra.forEach(function (c) { if (!seen[plainId(c.id)]) { catalog.push(c); seen[plainId(c.id)] = true; } });
      } catch (e) {}
    }
    var html = catalog.map(function (c) {
      var priceNum = Math.round((c.price || 0) * 100);
      var title = String(c.title || '');
      /* The catalog JSON carries no stock; a charm is treated as available unless it says available:false. */
      var avail = (c.available === false || c.available === 0 || c.available === '0') ? 0 : 1;
      return '<button type="button" class="upk-bc__charm' + (avail ? '' : ' is-soldout') + '" data-bc-charm data-id="' + plainId(c.id) + '" data-price="' + priceNum + '" data-label="' + title.replace(/"/g, '&quot;') + '" data-available="' + avail + '" aria-pressed="false"' + (avail ? '' : ' aria-disabled="true"') + '>' +
        '<span class="upk-bc__charm-ring">' + (c.image ? '<img src="' + c.image + '" alt="' + title.replace(/"/g, '&quot;') + '" width="60" height="60" loading="lazy">' : '<span class="upk-bc__charm-dot">' + escAttr(title.slice(0, 1)) + '</span>') + '</span>' +
        '<span class="upk-bc__charm-badge" data-bc-charm-badge hidden></span>' +
        (avail ? '' : '<span class="upk-bc__charm-soldout">Sold out</span>') +
        '</button>';
    }).join('');
    grid.innerHTML = html;
  }

  class UpkBandCharmEl extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var grid = this.querySelector('[data-bc-grid][data-bc-catalog-mode]');
      if (grid) buildCharmGrid(grid);

      var dataEl = this.querySelector('[data-bc-data]');
      var cfg = {};
      try { cfg = JSON.parse(dataEl.textContent); } catch (e) { cfg = {}; }

      this.min = parseInt(this.dataset.min || cfg.min || 1, 10);
      this.max = parseInt(this.dataset.max || cfg.max || 999, 10);
      this.listing = this.dataset.listing || cfg.listing || document.title;
      this.startingPrice = parseFloat(this.dataset.startingPrice || cfg.startingPrice || 0) * 100;
      this.ctaLabel = cfg.cta || 'Add to bag';

      var frame = this.querySelector('[data-bc-preview-frame]');
      this.arc = null;
      this.previewImageOverride = frame ? (frame.dataset.bcImageOverride || '') : '';
      if (frame && frame.dataset.bcArc) {
        var parts = frame.dataset.bcArc.split(',').map(function (n) { return parseFloat(n); });
        if (parts.length === 5 && parts.every(function (n) { return !isNaN(n); })) {
          this.arc = { cx: parts[0], cy: parts[1], r: parts[2], start: parts[3], end: parts[4] };
          frame.classList.add('upk-bc__preview-frame--arc');
        }
      }

      this.bandEls = Array.prototype.slice.call(this.querySelectorAll('[data-bc-band]'));
      this.charmEls = Array.prototype.slice.call(this.querySelectorAll('[data-bc-charm]'));

      this.band = null;
      this.charms = [];
      this._cutCache = {};
      this._pvToken = 0;

      var self = this;
      this.bandEls.forEach(function (el) {
        el.addEventListener('click', function () { self.selectBand(el); });
      });
      this.charmEls.forEach(function (el) {
        el.addEventListener('click', function () { self.addCharm(el); });
      });

      var atc = this.querySelector('[data-bc-atc]');
      if (atc) atc.addEventListener('click', function () { self.addToCart(false); });
      var buynow = this.querySelector('[data-bc-buynow]');
      if (buynow) buynow.addEventListener('click', function () { self.addToCart(true); });

      /* P13a A3: the selection strip under the main photo (snippets/upk-bc-strip, outside this element) carries the same
         remove buttons as the builder's own row; one document listener serves it. */
      if (!window.__upkBcStripBound) {
        window.__upkBcStripBound = true;
        document.addEventListener('click', function (e) {
          var b = e.target && e.target.closest ? e.target.closest('[data-bc-strip-remove]') : null;
          if (!b) return;
          var host = document.querySelector('upk-band-charm');
          if (host && typeof host.removeAt === 'function') host.removeAt(parseInt(b.getAttribute('data-bc-strip-remove'), 10));
        });
      }

      this.addEventListener('change', function (e) {
        if (e.target && e.target.matches && (e.target.matches('[data-upk-giftbox-check]') || e.target.matches('[data-upk-giftopt-check]') || e.target.matches('[data-upk-giftopt-select]'))) {
          self.render();
        }
      });

      if (this.bandEls.length >= 1) {
        this.selectBand(this.bandEls[0]);
      } else {
        this.render();
      }
    }

    selectBand(el) {
      this.band = {
        id: el.dataset.id,
        price: parseFloat(el.dataset.price) || 0,
        label: el.dataset.label,
        image: this.previewImageOverride || el.dataset.image || ''
      };
      this.bandEls.forEach(function (b) {
        b.classList.toggle('is-active', b === el);
        b.setAttribute('aria-checked', b === el ? 'true' : 'false');
      });
      /* 21 Oct (Zainab): the big product gallery no longer switches to the band photo when a finish is picked; the
         band and charms show only in the preview under Add to cart. */
      this.render();
    }

    addCharm(el) {
      /* P4b.4a: a sold-out charm (data-available 0) cannot be picked. */
      if (el.dataset.available === '0' || el.classList.contains('is-soldout')) { this.showError(el.dataset.label + ' is sold out. Pick another charm.'); return; }
      if (this.charms.length >= this.max) return;
      var img = el.querySelector('img');
      this.charms.push({
        id: el.dataset.id,
        price: parseFloat(el.dataset.price) || 0,
        label: el.dataset.label,
        image: img ? img.src : '',
        available: el.dataset.available !== '0'
      });
      this.render();
    }

    showError(msg) {
      var errorEl = this.querySelector('[data-bc-error]');
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    /* P4b.4a: drops any charm whose variant is sold out (it can be in the selection only if stock changed under the
       customer) and says which one; returns the names removed. */
    dropSoldOut() {
      var gone = this.charms.filter(function (c) { return c.available === false; });
      if (!gone.length) return [];
      this.charms = this.charms.filter(function (c) { return c.available !== false; });
      var names = [];
      gone.forEach(function (c) { if (names.indexOf(c.label) === -1) names.push(c.label); });
      this.render();
      this.showError(names.join(', ') + (names.length > 1 ? ' are' : ' is') + ' sold out and ' + (names.length > 1 ? 'were' : 'was') + ' removed from your selection. Pick another charm.');
      return names;
    }

    removeAt(index) {
      if (index >= 0 && index < this.charms.length) this.charms.splice(index, 1);
      this.render();
    }

    qtyById() {
      var map = {};
      this.charms.forEach(function (c) { map[c.id] = (map[c.id] || 0) + 1; });
      return map;
    }

    giftPriceCents() {
      var box = this.querySelector('[data-upk-giftbox]');
      var total = 0;
      if (!box) return 0;
      var mainCheck = box.querySelector('[data-upk-giftbox-check]');
      if (mainCheck && mainCheck.checked) total += parseFloat(box.dataset.giftPrice) || 0;
      if (window.upkGiftAddonPrice) total += window.upkGiftAddonPrice(box) || 0;
      return total;
    }

    // Single source of truth for the order's rupee total, used by both
    // render() (for display) and addToCart() (for the zero-value guard),
    // so the two can never disagree about what the order is actually worth.
    currentTotalCents() {
      var charmSum = 0;
      this.charms.forEach(function (c) { charmSum += c.price; });
      var giftCents = this.giftPriceCents();
      return (this.band ? this.band.price + charmSum : this.startingPrice) + giftCents;
    }

    cutout(charm) {
      if (this._cutCache[charm.id]) return this._cutCache[charm.id];
      this._cutCache[charm.id] = new Promise(function (resolve) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () {
          try { resolve(keyOutWhite(im)); } catch (e) { resolve(null); }
        };
        im.onerror = function () { resolve(null); };
        im.src = charm.image;
      });
      return this._cutCache[charm.id];
    }

    render() {
      var self = this;
      var qtyMap = this.qtyById();

      this.charmEls.forEach(function (el) {
        var qty = qtyMap[el.dataset.id] || 0;
        el.classList.toggle('is-active', qty > 0);
        el.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');
        var atMax = self.charms.length >= self.max;
        el.classList.toggle('is-disabled', atMax && el.dataset.available !== '0');
        var badge = el.querySelector('[data-bc-charm-badge]');
        if (badge) {
          if (qty >= 1) { badge.hidden = false; badge.textContent = qty; }
          else { badge.hidden = true; badge.textContent = ''; }
        }
      });

      var countEl = this.querySelector('[data-bc-count]');
      if (countEl) countEl.textContent = this.charms.length;

      var bandValEls = this.querySelectorAll('[data-bc-band-val]');
      bandValEls.forEach(function (el) {
        el.textContent = self.band ? (': ' + self.band.label) : '';
      });

      var seq = this.querySelector('[data-bc-seq]');
      var seqEmpty = this.querySelector('[data-bc-seq-empty]');
      if (seq) {
        var items = seq.querySelectorAll('.upk-bc__seq-item');
        for (var i = 0; i < items.length; i++) { items[i].remove(); }
        var html = '';
        this.charms.forEach(function (c, idx) {
          html += '<span class="upk-bc__seq-item"><span class="upk-bc__seq-img"><img src="' + c.image + '" alt="' + c.label + '"></span><button type="button" class="upk-bc__seq-remove" data-bc-remove-idx="' + idx + '" aria-label="Remove ' + c.label + '">&times;</button></span>';
        });
        if (html) {
          if (seqEmpty) seqEmpty.hidden = true;
          seqEmpty.insertAdjacentHTML('afterend', html);
        } else if (seqEmpty) {
          seqEmpty.hidden = false;
        }
        seq.querySelectorAll('[data-bc-remove-idx]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.removeAt(parseInt(btn.getAttribute('data-bc-remove-idx'), 10)); });
        });
      }

      var charmSum = 0;
      this.charms.forEach(function (c) { charmSum += c.price; });

      var bandLineLabel = this.querySelector('[data-bc-band-line-label]');
      var bandLinePrice = this.querySelector('[data-bc-band-line-price]');
      if (bandLineLabel) bandLineLabel.textContent = this.band ? this.band.label : 'Band';
      if (bandLinePrice) bandLinePrice.textContent = fmtINR(this.band ? this.band.price : this.startingPrice);

      // Chain price note ("₹X is the chain price only"), always mirrors
      // whichever finish/band is currently selected, instead of a hardcoded
      // number, so it stays correct across products/variants priced ₹500,
      // ₹750, ₹1,500, etc.
      var chainPriceVal = this.querySelector('[data-bc-chain-price-val]');
      if (chainPriceVal) chainPriceVal.textContent = fmtINR(this.band ? this.band.price : this.startingPrice);

      var charmCountEl = this.querySelector('[data-bc-charmcount]');
      var charmTotalEl = this.querySelector('[data-bc-charmtotal]');
      if (charmCountEl) charmCountEl.textContent = this.charms.length;
      if (charmTotalEl) charmTotalEl.textContent = fmtINR(charmSum);

      var totalCents = this.currentTotalCents();

      var totalEl = this.querySelector('[data-bc-total]');
      if (totalEl) totalEl.textContent = fmtINR(totalCents);

      /* P13a A3: the strip under the main photo mirrors the selection: same order, same remove buttons, "n of max" and the
         running total (band plus charms plus the gift box when ticked). The rail scrolls to the newest charm. */
      var strips = document.querySelectorAll('[data-bc-strip]');
      if (strips.length) {
        var stripHtml = '';
        this.charms.forEach(function (c, idx) {
          stripHtml += '<span class="upk-bc-strip__item">' + (c.image ? '<img src="' + escAttr(c.image) + '" alt="' + escAttr(c.label) + '" width="28" height="28">' : '<span class="upk-bc-strip__letter">' + escAttr(String(c.label || '').slice(0, 1)) + '</span>') + '<button type="button" class="upk-bc-strip__remove" data-bc-strip-remove="' + idx + '" aria-label="Remove ' + escAttr(c.label) + '">&times;</button></span>';
        });
        var stripCount = this.charms.length;
        var stripMax = this.max;
        var stripTotal = fmtINR(totalCents);
        Array.prototype.forEach.call(strips, function (s) {
          var rail = s.querySelector('[data-bc-strip-rail]');
          var empty = s.querySelector('[data-bc-strip-empty]');
          if (rail) {
            Array.prototype.forEach.call(rail.querySelectorAll('.upk-bc-strip__item'), function (n) { n.remove(); });
            if (stripHtml) rail.insertAdjacentHTML('beforeend', stripHtml);
          }
          if (empty) empty.hidden = stripCount > 0;
          var ce = s.querySelector('[data-bc-strip-count]'); if (ce) ce.textContent = stripCount;
          var me = s.querySelector('[data-bc-strip-max]'); if (me) me.textContent = stripMax;
          var te = s.querySelector('[data-bc-strip-total]'); if (te) te.textContent = stripTotal;
          s.classList.toggle('has-charms', stripCount > 0);
          if (rail && stripCount) { try { rail.scrollTo({ left: rail.scrollWidth, behavior: 'smooth' }); } catch (err) { rail.scrollLeft = rail.scrollWidth; } }
        });
      }

      document.querySelectorAll('[data-upk-bc-price]').forEach(function (el) {
        el.textContent = fmtINR(totalCents);
      });

      var errorEl = this.querySelector('[data-bc-error]');
      var ready = !!this.band && this.charms.length >= this.min && this.charms.length <= this.max && totalCents > 0;
      var msg = '';
      if (!this.band) msg = 'Choose a finish to start';
      else if (this.charms.length < this.min) {
        var remaining = this.min - this.charms.length;
        msg = 'Pick ' + remaining + ' more charm' + (remaining > 1 ? 's' : '');
      } else if (totalCents <= 0) {
        msg = 'This piece cannot be ordered online yet. Message us on WhatsApp.';
      }
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.hidden = !msg;
      }

      var atc = this.querySelector('[data-bc-atc]');
      if (atc) atc.disabled = !ready;
      var buynow = this.querySelector('[data-bc-buynow]');
      if (buynow) buynow.disabled = !ready;
      var atcLabel = this.querySelector('[data-bc-atc-label]');
      if (atcLabel) atcLabel.textContent = ready ? (this.ctaLabel + ' · ' + fmtINR(totalCents)) : (this.band ? 'Pick your charms' : 'Choose a finish');

      this.renderPreview();
    }

    renderPreview() {
      var self = this;
      var frame = this.querySelector('[data-bc-preview-frame]');
      var bandImg = this.querySelector('[data-bc-preview-band]');
      var row = this.querySelector('[data-bc-mock-row]');
      var emptyEl = this.querySelector('[data-bc-preview-empty]');
      var captionEl = this.querySelector('[data-bc-preview-caption]');
      if (!frame) return;

      if (this.band && this.band.image) {
        bandImg.src = this.band.image;
        frame.hidden = false;
        if (emptyEl) emptyEl.hidden = true;
      } else {
        frame.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
      }

      if (captionEl) {
        captionEl.textContent = this.band
          ? (this.band.label + ' finish · ' + this.charms.length + ' charm' + (this.charms.length !== 1 ? 's' : ''))
          : '';
      }

      if (!row) return;
      var n = this.charms.length;
      var token = ++this._pvToken;
      if (!this.band || !n) { row.innerHTML = ''; return; }
      var sel = this.charms.slice();
      Promise.all(sel.map(function (c) { return self.cutout(c); })).then(function (srcs) {
        if (token !== self._pvToken) return;
        if (self.arc) {
          self.layoutArc(row, sel, srcs);
        } else {
          row.innerHTML = srcs.map(function (src, idx) {
            var c = sel[idx];
            if (src) return '<img class="upk-bc__mock-charm" src="' + src + '" alt="' + c.label + '">';
            return '<img class="upk-bc__mock-charm upk-bc__mock-charm--chip" src="' + c.image + '" alt="' + c.label + '">';
          }).join('');
        }
      });
    }

    layoutArc(row, sel, srcs) {
      var arc = this.arc;
      var n = sel.length;
      row.innerHTML = '';
      row.classList.add('upk-bc__mock-row--arc');

      var fullSpread = arc.end - arc.start;
      var pitchDeg = 30;
      var maxAbs = Math.min(Math.abs(fullSpread), pitchDeg * (n - 1));
      var spread = fullSpread < 0 ? -maxAbs : maxAbs;
      var mid = (arc.start + arc.end) / 2;
      var start2 = mid - spread / 2;
      var end2 = mid + spread / 2;

      sel.forEach(function (c, i) {
        // Reversed on purpose, see renderPreviewArc in upk-personalise.js
        // for the full explanation: this makes pick order read left-to-right
        // on screen instead of backwards for a typical bottom-of-chain arc.
        var t = n === 1 ? 0.5 : (n - 1 - i) / (n - 1);
        var thetaDeg = n === 1 ? mid : start2 + (end2 - start2) * t;
        var theta = thetaDeg * Math.PI / 180;
        var x = arc.cx + arc.r * Math.cos(theta);
        var y = arc.cy + arc.r * Math.sin(theta);
        var src = srcs[i];
        var ring = document.createElement('span');
        ring.className = 'upk-bc__mock-ring';
        ring.style.left = x + '%';
        ring.style.top = y + '%';
        row.appendChild(ring);
        var img = document.createElement('img');
        img.alt = c.label;
        img.className = src ? 'upk-bc__mock-charm' : 'upk-bc__mock-charm upk-bc__mock-charm--chip';
        img.src = src || c.image;
        img.style.left = x + '%';
        img.style.top = y + '%';
        row.appendChild(img);
      });
    }

    giftItems() {
      var self = this;
      var items = [];
      var box = this.querySelector('[data-upk-giftbox]');
      if (!box) return items;

      var mainCheck = box.querySelector('[data-upk-giftbox-check]');
      if (mainCheck && mainCheck.checked) {
        var mainId = parseInt(box.dataset.giftVariantId, 10);
        if (mainId) {
          var props = { 'For': self.listing, 'Gift Wrap': 'Yes' };
          var msgEl = box.querySelector('[data-upk-giftbox-msg]');
          if (msgEl && msgEl.value.trim()) props['Gift Message'] = msgEl.value.trim();
          items.push({ id: mainId, quantity: 1, properties: props });
        }
      }

      if (window.upkGiftAddonItems) {
        var addonItems = window.upkGiftAddonItems(box) || [];
        addonItems.forEach(function (gi) {
          gi.properties = gi.properties || {};
          gi.properties['For'] = self.listing;
          items.push(gi);
        });
      }
      return items;
    }

    buildItems() {
      var groupId = 'bc_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);
      var arrangement = this.charms.map(function (c) { return c.label; }).join(' + ');
      var items = [];
      items = items.concat(this.giftItems());
      for (var i = this.charms.length - 1; i >= 0; i--) {
        var c = this.charms[i];
        items.push({
          id: plainId(c.id),
          quantity: 1,
          properties: { 'For': this.listing, '_upk_bc_group': groupId, '_upk_bc_role': 'Charm', '_upk_bc_order': String(i + 1) }
        });
      }
      items.push({
        id: plainId(this.band.id),
        quantity: 1,
        properties: {
          'For': this.listing,
          'Personalisation': arrangement,
          '_upk_bc_group': groupId,
          '_upk_bc_role': 'Band',
          '_pz_head': 'true',
          '_pz_edit': window.location.pathname
        }
      });
      return items;
    }

    addToCart(goToCheckout) {
      var self = this;
      var atc = this.querySelector('[data-bc-atc]');
      var buynow = this.querySelector('[data-bc-buynow]');
      if (this.dropSoldOut().length) return;
      if (!this.band || this.charms.length < this.min || this.charms.length > this.max) return;
      if (this.currentTotalCents() <= 0) {
        var zErrorEl = this.querySelector('[data-bc-error]');
        if (zErrorEl) {
          zErrorEl.textContent = 'This item is currently unavailable for purchase. Please contact us for help.';
          zErrorEl.hidden = false;
        }
        return;
      }
      if (atc) atc.disabled = true;
      if (buynow) buynow.disabled = true;

      var items = this.buildItems();

      var body = { items: items };
      if (!goToCheckout) {
        body.sections = ['cart-drawer', 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (result) {
          if (result && result.status && Number(result.status) >= 400) {
            throw new Error(result.description || result.message || 'Could not add to cart');
          }
          if (goToCheckout) {
            // Verify the REAL cart total via /cart.js before allowing
            // checkout, never trust a locally-estimated total. Below the
            // minimum order value, send to /cart instead, where the
            // existing minimum-order message is already shown.
            var root_ = upkRoot();
            fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
              .then(function (r2) { return r2.json(); })
              .then(function (cart) {
                if (cart && cart.total_price >= UPK_MIN_ORDER_PAISE) {
                  window.location.href = root_ + 'checkout';
                } else {
                  try { sessionStorage.setItem('upkOpenCartOnLoad', '1'); } catch (e) {}
                  window.location.href = root_ + 'cart';
                }
              })
              .catch(function () {
                // Couldn't verify the real total, fail safe to the cart
                // rather than risk sending an unverified order to checkout.
                window.location.href = root_ + 'cart';
              });
            return;
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && result.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(result);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'upk-band-charm-builder' });
          }
        })
        .catch(function (err) {
          /* P4b.4a: never a message the customer cannot act on. A stock error names the charm when the message carries it
             and says what to do; anything else says to try again or message us. */
          var raw = (err && err.message) || '';
          var msg;
          if (/sold out|out of stock|availab|inventory|stock/i.test(raw)) {
            var named = self.charms.filter(function (c) { return raw.indexOf(c.label) > -1; }).map(function (c) { return c.label; });
            msg = (named.length ? named.join(', ') + ' is sold out.' : 'One of your charms is sold out.') + ' Remove it from your selection and pick another charm.';
            self.charms.forEach(function (c) { if (named.indexOf(c.label) > -1) c.available = false; });
            self.charmEls.forEach(function (el) { if (named.indexOf(el.dataset.label) > -1) { el.dataset.available = '0'; el.classList.add('is-soldout'); el.setAttribute('aria-disabled', 'true'); if (!el.querySelector('.upk-bc__charm-soldout')) el.insertAdjacentHTML('beforeend', '<span class="upk-bc__charm-soldout">Sold out</span>'); } });
          } else {
            msg = 'Something went wrong adding this to your cart. Please try again, or message us on WhatsApp and we will help.';
          }
          self.showError(msg);
        })
        .finally(function () {
          if (atc) atc.disabled = false;
          if (buynow) buynow.disabled = false;
        });
    }
  }

  customElements.define('upk-band-charm', UpkBandCharmEl);
})();
